import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import bookishTheme from './theme';
import Layout from './components/Layout';
import Home from './components/Home';
import Calendar from './components/Calendar';
import Blog from './components/Blog';
import Login from './components/Login';
import Register from './components/Register';
import PublisherForm from './components/PublisherForm';
import BookReleaseForm from './components/BookReleaseForm';
import Release from './components/Release';
import UserManagement from './components/UserManagement';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider theme={bookishTheme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/releases/:id" element={<Release />} />
              <Route
                path="/publishers/new"
                element={
                  <ProtectedRoute>
                    <PublisherForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/book-releases/new"
                element={
                  <ProtectedRoute>
                    <BookReleaseForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/book-releases/edit/:id"
                element={
                  <ProtectedRoute>
                    <BookReleaseForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <ProtectedRoute>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
